import react from 'react'

import './Main.scss'

const Main = _ => {

    return (
        <main>
            
            <p> iPhone Xs </p>

            <h1> Welcome to The Big Screens. </h1>

            <button> SHOP NOW! </button>

        </main>
    )
}

export default Main